import React, { useState, useEffect } from "react"

import { Button, Card, CardContent, Grid } from "@mui/material"
import { TCInput } from "components/TopCourtComponents/Input/TopCourtInput"
import { TCLabel } from "components/TopCourtComponents/Label/TopCourtLabel"

import { dayOptions, timeOptions } from "constant/constant"
import { getSportCourtTypes } from "services/placeServices"
import { getCourtTypes } from "services/placeServices"
import { courtTypeOption } from "constant/constant"

import Select from "react-select";

import { IconTrash, IconArrowBackUp } from "@tabler/icons"
import { validation } from "helper/Form"

const form = {
    days: "",
    sportCourtType: "",
    startHours: "",
    endHours: "",
    price: "",
}

function PriceListComponent({
    data,
    isException,
    index,
    savePrice,
    formId,
    deletePrice,
    merchantId
}) {
    const [sportCourtTypeOptions, setSportCourtTypeOptions] = useState([])
    const [joi, setJOI] = useState({
        ...form
    })

    const loadSportCourtTypeOptions = async () => {
        let { data, error } = await getSportCourtTypes({ isActive: true, merchantId, placeId: formId })
        if (error) { console.log(error) }
        if (data) {
            let sportCourtType = []
            for (let i = 0; i < data.length; i++) {
                sportCourtType.push({
                    label: data[i].sportTypeId?.name + ' ' + data[i].courtTypeId?.name,
                    value: data[i]._id
                })
            }
            setSportCourtTypeOptions(sportCourtType)
        }
    }

    const [courtType, setCourtType] = useState(courtTypeOption)

    // const loadCourtType = async () => {
    //     let { data, error } = await getCourtTypes({ isActive: true })
    //     if (error) { console.log(error) }
    //     if (data) {
    //         let courtType = []
    //         for (let i = 0; i < data.length; i ++) {
    //             courtType.push({
    //                 label: data[i].name,
    //                 value: data[i].courtType
    //             })
    //         }
    //         setCourtType(courtType)
    //     }
    // }

    const [priceForm, setPriceForm] = useState({
        price: 0,
        ...data,
        days: (data && data.dayString) ? getOptionObject({ value: data.dayString, options: dayOptions }) : "",
        type: (data && data.courtType) ? getOptionObject({ value: data.courtType, options: courtType }) : "",
        startHours: (data && data.startHours) ? getOptionObject({ value: data.startHours, options: timeOptions }) : "",
        endHours: (data && data.endHours) ? getOptionObject({ value: data.endHours, options: timeOptions }) : "",
        isPriceDeleted: false,
    })

    const onChangeForm = (e) => {
        setPriceForm(prev => ({
            ...prev,
            ...e
        }))
    }

    // useEffect(() => {
    //     loadCourtType()
    // }, [])

    useEffect(() => {
        loadSportCourtTypeOptions()
    }, [])

    useEffect(() => {
        console.log('data price', data)
        setPriceForm(prev => ({
            ...prev,
            sportCourtTypeSelected: data.sportCourtTypeId ? getOptionObject({ value: data.sportCourtTypeId, options: sportCourtTypeOptions }) : "",
        }));
    }, [sportCourtTypeOptions]);

    useEffect(() => {
        // console.log('here is priceForm', priceForm)
        
        if (priceForm.isPriceDeleted) {
            setJOI(({
                ...joi
            }))
        } else {
            setJOI(prev => ({
                days: !validation.isNotEmpty(priceForm.days) && isException ? "*required" : "",
                sportCourtType: !validation.isNotEmpty(priceForm.sportCourtTypeSelected) ? "*required" : "",
                startHours: !validation.isNotEmpty(priceForm.startHours) ? "*required" : "",
                endHours: !validation.isNotEmpty(priceForm.endHours) ? "*required" : "",
                price: !validation.isNotEmpty(priceForm.price) ? "*required" : "",
            }))
        }
        savePrice(priceForm, index, (joi != form))
    }, [priceForm])

    const updateSessionPrice = async () => {
        let isDeleted = priceForm.isPriceDeleted
        if (isDeleted) {
            isDeleted = false
        } else {
            isDeleted = true
        }
        console.log(isDeleted)
        setPriceForm(prev => ({
            ...prev,
            isPriceDeleted: isDeleted
        }))
    }

    const startTimeOptions = priceForm.endHours && priceForm.endHours.value ? timeOptions.filter(opt => opt.value < priceForm.endHours.value) : timeOptions
    const endTimeOptions = priceForm.startHours && priceForm.startHours.value ? timeOptions.filter(opt => opt.value > priceForm.startHours.value) : timeOptions

    return (
        <Card sx={{
            mt: 1,
            boxShadow: "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;"
        }}>
            <Grid p={2} container>
                <div style={{
                    width: '100%',
                    textAlign: 'right'
                }}>
                    {
                        (priceForm.isPriceDeleted) ?
                            <IconArrowBackUp style={{
                                cursor: 'pointer',
                                color: '#4caf50'
                            }} onClick={() => {
                                updateSessionPrice()
                            }} />
                            :
                            <IconTrash style={{
                                cursor: 'pointer',
                                color: 'red'
                            }} onClick={() => {
                                if (formId) {
                                    updateSessionPrice()
                                    setJOI(prev => ({
                                        ...form
                                    }))
                                } else {
                                    deletePrice(data._id)
                                }
                            }} />
                    }
                </div>
                <Grid item container xs={12} style={{
                    opacity: priceForm.isPriceDeleted ? 0.5 : 1,
                    transition: "all 0.3s ease-in-out"
                }}>
                    <Grid item xs={12} md={2} sx={{ p: 1 }}>
                        <TCLabel showAlert={joi.days}>Day</TCLabel>
                        <Select
                            menuPortalTarget={document.body}
                            isDisabled={!isException || priceForm.isPriceDeleted}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            value={!isException ? {
                                value: 'all',
                                label: "All Days"
                            } : priceForm.days}
                            onChange={(e) => {
                                onChangeForm({
                                    days: e
                                })
                            }}
                            options={dayOptions}
                        />
                    </Grid>
                    <Grid item xs={12} md={3} sx={{ p: 1 }}>
                        <TCLabel showAlert={joi.sportCourtType}>Sport Court Type</TCLabel>
                        <Select
                            menuPortalTarget={document.body}
                            isDisabled={priceForm.isPriceDeleted}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            value={priceForm.sportCourtTypeSelected} onChange={(e) => {
                                onChangeForm({
                                    sportCourtTypeId: e.value,
                                    sportCourtTypeSelected: e
                                })
                            }} options={sportCourtTypeOptions} />
                    </Grid>
                    <Grid item xs={12} md={4} sx={{ p: 1 }}>
                        <TCLabel showAlert={joi.startHours || joi.endHours}>Range Hours</TCLabel>
                        <Grid container direction={"row"}>
                            <Grid item xs={6} pr={1}>
                                <Select
                                    menuPortalTarget={document.body}
                                    isDisabled={priceForm.isPriceDeleted}
                                    value={priceForm.startHours}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    options={startTimeOptions}
                                    onChange={(e) => {
                                        onChangeForm({ startHours: e })
                                    }}
                                />
                            </Grid>
                            <Grid item xs={6} pl={1}>
                                <Select
                                    menuPortalTarget={document.body}
                                    isDisabled={priceForm.isPriceDeleted}
                                    value={priceForm.endHours}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    options={endTimeOptions}
                                    onChange={(e) => {
                                        onChangeForm({ endHours: e })
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={3} sx={{ p: 1 }}>
                        <TCLabel showAlert={joi.price}>Price</TCLabel>
                        <TCInput value={priceForm.price} onChange={(e) => {
                            const raw = e.currentTarget.value
                            const digits = raw.replace(/\D/g, '')
                            onChangeForm({ price: digits })
                        }} placeHolder="Input price" disabled={priceForm.isPriceDeleted}></TCInput>
                    </Grid>
                </Grid>
            </Grid>
        </Card>
    )
}

function getOptionObject({
    value, options
}) {

    // console.log(value, options)

    let selectedValue = null
    for (let i = 0; i < options.length; i++) {
        if (options[i].value.toString() === value.toString()) {
            selectedValue = options[i]
        }
    }
    // console.log('here is selectedValue', selectedValue)
    return selectedValue
}

export default PriceListComponent